import { EventDispatcher } from 'three';
import { ActionTypes } from '../constants/ActionTypes';

const enable = (el) => {
    el.removeAttribute('disabled');
    el.removeAttribute('aria-disabled');
};

const disable = (el) => {
    el.setAttribute('disabled', true);
    el.setAttribute('aria-disabled', true);
};

const unitNameAttr = 'data-unit-name';
const actionAttr = 'data-action-key';

export const DOMActionButtonEvent = {
    FOCUS_REQUEST: 'focusRequest',
    BLUR_REQUEST: 'blurRequest'
};

class DOMActionButtonMediator extends EventDispatcher {
    constructor(el) {
        super();

        let root = typeof el === 'string' ? document.querySelector(el) : el;

        if (!root) root = document;

        const units = [...root.querySelectorAll(`[${unitNameAttr}]`)];
        let items = [];
        const actionTypesObj = {};

        // let unit;
        // let unitName;
        for (let i = 0; i < units.length; i += 1) {
            const unit = units[i];
            const unitName = unit.getAttribute(unitNameAttr);

            if (unit.hasAttribute(actionAttr)) {
                items.push(unit);
                actionTypesObj[unit.getAttribute(actionAttr)] = true;

                // DISABLE UNTIL ENTERED
                disable(unit);
            }

            const unitItems = [...unit.querySelectorAll(`[${actionAttr}]`)];

            unitItems.forEach((item) => {
                // console.log(item, unit, unitName, i);
                if (!item.hasAttribute(unitNameAttr)) {
                    item.setAttribute(unitNameAttr, unitName);
                }

                actionTypesObj[item.getAttribute(actionAttr)] = true;

                // DISABLE UNTIL ENTERED
                disable(item);
            });
            items = items.concat(unitItems);
        }

        this._items = items;
        this.actionTypes = Object.keys(actionTypesObj);

        this._started = false;
        this.hasStart = this.actionTypes.length > 0;
    }

    start() {
        if (this._started) return;

        this._itemsHandlers = this._items.map((item) => {
            const h = (evt) => {
                if (evt.type === 'keydown' && evt.keyCode !== 13) return;

                this._handleClick(evt, item);
            };

            const fh = () => {
                this._handleFocus(item, true);
            };

            const bh = () => {
                this._handleFocus(item, false);
            };

            item.addEventListener('click', h);
            item.addEventListener('keydown', h);
            item.addEventListener('focus', fh);
            item.addEventListener('blur', bh);

            // ENABLE
            enable(item);

            return {
                click: h,
                keydown: h,
                focus: fh,
                blur: bh
            };
        });

        this._started = true;
    }

    _handleFocus(item, forth) {
        const unitName = item.getAttribute(unitNameAttr);
        const actionKey = item.getAttribute(actionAttr);
        const actionElementId = item.getAttribute('data-action-element-id');

        console.log(item, forth);

        this.dispatchEvent({
            type: forth ? DOMActionButtonEvent.FOCUS_REQUEST : DOMActionButtonEvent.BLUR_REQUEST,
            unitName,
            actionKey,
            actionElementId
        });
    }

    _handleClick(evt, item) {
        const actionKey = item.getAttribute(actionAttr);
        const unitName = item.getAttribute(unitNameAttr);
        let param;

        switch (actionKey) {
            case ActionTypes.SHOW_WORK_DETAILS:
                param = item.getAttribute('data-work-id');

                this.dispatchEvent({
                    type: actionKey,
                    workId: param
                });

                break;

            case ActionTypes.CURRENT_MASK_LINK_REQUEST:
                param = item.getAttribute('data-action-social');

                this.dispatchEvent({
                    unitName,
                    type: actionKey,
                    social: param
                });

                break;

            case ActionTypes.PREV_MASK_REQUEST:
            case ActionTypes.NEXT_MASK_REQUEST:
                this.dispatchEvent({
                    unitName,
                    type: actionKey
                });

                break;

            default:
                console.warn('Action is not supported');

                break;
        }
    }
}

export default DOMActionButtonMediator;
